import React from 'react';
import styles from './mapTilePattern.module.scss';

const MapTilePattern: React.FC = () => {
  return (
    <span className={styles.pattern} aria-hidden="true">
      <span className={styles.topLeft} />
      <span className={styles.topRight} />
      <span className={styles.midRight} />
      <span className={styles.highlight} />
      <span className={styles.bottomRight} />
    </span>
  );
};

export default MapTilePattern;
